import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Music2 } from "lucide-react";
import { useSettings } from "../lib/SettingsContext";

export default function Footer() {
  const settings = useSettings();
  const social = settings?.social || {};
  const socialLinks = [
    { key: "facebook", Icon: Facebook, label: "Facebook" },
    { key: "instagram", Icon: Instagram, label: "Instagram" },
    { key: "tiktok", Icon: Music2, label: "TikTok" },
    { key: "youtube", Icon: Youtube, label: "YouTube" },
  ];

  return (
    <footer data-testid="main-footer" className="border-t border-[rgba(198,167,106,0.2)] bg-[#050814] mt-24">
      <div className="dl-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="serif text-2xl tracking-[0.16em] text-[#F3E9D2]">DOROTHÉE LANCELOT</div>
            <p className="dl-eyebrow mt-2" style={{ fontSize: "0.6rem" }}>
              Auteure • Médium • Conférencière • Onirothérapeute
            </p>
            <p className="text-sm text-[#F3E9D2]/55 mt-5 max-w-md leading-relaxed">
              Un nom, plusieurs univers. Des livres, des conférences, des histoires et une communauté
              qui s'est construite au fil des années.
            </p>
            <div className="flex gap-4 mt-6">
              {socialLinks.filter(({ key }) => social[key]?.url).map(({ key, Icon, label }) => {
                const url = social[key]?.url;
                return (
                  <a
                    key={key}
                    href={url || "#"}
                    target={url ? "_blank" : undefined}
                    rel="noreferrer"
                    data-testid={`footer-social-${key}`}
                    aria-label={label}
                    className={`w-10 h-10 flex items-center justify-center border border-[rgba(198,167,106,0.3)] text-[#D4B978] transition-colors hover:bg-[#C6A76A] hover:text-[#050814] ${
                      url ? "" : "opacity-40 pointer-events-none"
                    }`}
                  >
                    <Icon size={17} />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="dl-eyebrow mb-4">Explorer</h4>
            <ul className="space-y-2.5 text-sm text-[#F3E9D2]/70">
              <li><Link className="hover:text-[#D4B978]" to="/livres">Livres</Link></li>
              <li><Link className="hover:text-[#D4B978]" to="/consultations">Consultations</Link></li>
              <li><Link className="hover:text-[#D4B978]" to="/conferences">Conférences</Link></li>
              <li><Link className="hover:text-[#D4B978]" to="/les-chroniques-de-letrange">Les Chroniques de l'Étrange</Link></li>
             
            </ul>
          </div>

          <div>
            <h4 className="dl-eyebrow mb-4">Informations</h4>
            <ul className="space-y-2.5 text-sm text-[#F3E9D2]/70">
              <li><Link className="hover:text-[#D4B978]" to="/mentions-legales">Mentions légales</Link></li>
              <li><Link className="hover:text-[#D4B978]" to="/confidentialite">Confidentialité</Link></li>
              <li><Link className="hover:text-[#D4B978]" to="/cookies">Cookies</Link></li>
              <li><Link className="hover:text-[#D4B978]" to="/cgv">CGV</Link></li>
            </ul>
          </div>
        </div>

        <div className="dl-gold-line my-10 opacity-40" />
        <div className="flex flex-col md:flex-row justify-between gap-4 text-[0.72rem] text-[#F3E9D2]/40 tracking-wide">
          <span>© {new Date().getFullYear()} Dorothée Lancelot. Tous droits réservés.</span>
          {settings?.siret_pro && <span data-testid="footer-siret">SIRET {settings.siret_pro}</span>}
        </div>
      </div>
    </footer>
  );
}
